/* Copyright (c) 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { FlexContainer, SVGIconProps, theme } from "@nordcloud/gnui";
import { ChartLegend } from "../ChartLegend";
import { StatusChart } from "../StatusChart";
import { TopWidgetCardWrap } from "../styles";
import { StatusChartItem } from "../types";
import { StatItem } from "./StatItem";

type Props = {
  items: StatusChartItem[];
  count: number | undefined;
  icon: SVGIconProps["name"];
  label: string;
  link: string;
  loading: boolean;
  isMobileView?: boolean;
};

export function StatusCard({
  items,
  count,
  icon,
  label,
  link,
  loading,
}: Props) {
  return (
    <TopWidgetCardWrap boxStyle="lightGrey">
      <StatItem
        icon={icon}
        label={label}
        count={count}
        link={link}
        loading={loading}
        layout="responsive-desktop-column"
      />
      <When condition={items.length > 0}>
        <FlexContainer
          direction="column"
          gap={theme.spacing.spacing03}
          alignItems="flex-start"
          css={{ flex: 1 }}
        >
          <StatusChart items={items} isDonutChart={false} chartLabel={label} />
          <ChartLegend
            items={items}
            loading={loading}
            direction="row"
            fontResponsivePoint={2000}
            itemWidthCh={23}
          />
        </FlexContainer>
      </When>
    </TopWidgetCardWrap>
  );
}
